export default __webpack_public_path__ + "static/LeituraSansTwo-Bold-0a59019556aeec00983e749592b6278c.woff2";